import { gettext } from '@eventbrite/i18n';
import { Icon, IconButton } from '@eventbrite/marmalade';
import React from 'react';
import { ArrowLeftIcon } from '../../../_shared/Icons/ArrowLeftIcon';
import { ArrowRightIcon } from '../../../_shared/Icons/ArrowRightIcon';
import styles from './AgendaScrollButtons.module.scss';
import { useAgendaScroll } from './hooks/useAgendaScroll';

export const AgendaScrollButtons = ({
    tabRef,
}: {
    tabRef: React.RefObject<HTMLDivElement>;
}) => {
    const { canPrev, canNext, onPrev, onNext } = useAgendaScroll(tabRef);

    return (
        <div className={styles.wrapper}>
            <IconButton
                className={canPrev ? styles.clickable : styles.notClickable}
                variant="onLightBackground"
                icon={
                    <Icon size="xsmall">
                        <ArrowLeftIcon
                            className={
                                canPrev
                                    ? styles.clickableIcon
                                    : styles.notClickableIcon
                            }
                        />
                    </Icon>
                }
                aria-label={gettext('Previous agenda page')}
                disabled={!canPrev}
                onClick={onPrev}
            />
            <IconButton
                className={canNext ? styles.clickable : styles.notClickable}
                variant="onLightBackground"
                icon={
                    <Icon size="xsmall">
                        <ArrowRightIcon
                            className={
                                canNext
                                    ? styles.clickableIcon
                                    : styles.notClickableIcon
                            }
                        />
                    </Icon>
                }
                aria-label={gettext('Next agenda page')}
                disabled={!canNext}
                onClick={onNext}
            />
        </div>
    );
};
